import { Link } from "@/components/marketing/elements/link"
import { ArrowNarrowRightIcon } from "@/components/marketing/icons/arrow-narrow-right-icon"
import { ResponsiveAppScreenshot } from "@/components/marketing/ResponsiveAppScreenshot"
import {
  Feature,
  FeaturesTwoColumnWithDemos,
} from "@/components/marketing/sections/features-two-column-with-demos"
import { AGENT_FEATURES } from "@/content/marketing/site-content"
import { primaryCtaHref, primaryCtaLabel } from "@/lib/launch-config"

export function MarketingAgentSection() {
  return (
    <FeaturesTwoColumnWithDemos
      id="agents"
      eyebrow="For AI agents"
      headline="Structured context an agent can act on, not prose it has to guess at"
      subheadline={
        <p>
          Connect a coding agent to the ArtlessDev MCP server for structured scenario content plus a live, queryable
          view of status and relationships — instead of guessing from scattered prose.
        </p>
      }
      features={
        <>
          {AGENT_FEATURES.map((item) => (
            <Feature
              key={item.id}
              demo={<ResponsiveAppScreenshot shot={item.shot} wallpaper={item.wallpaper} placement={item.placement} />}
              headline={item.headline}
              subheadline={<p>{item.subheadline}</p>}
              cta={
                <Link href={primaryCtaHref()}>
                  {primaryCtaLabel()} <ArrowNarrowRightIcon />
                </Link>
              }
            />
          ))}
        </>
      }
    />
  )
}
